<div class="row">
  <div class="col-12">
    @if (calculationResponse?.status === CalculationStatusEnum.Created && calculationResponse?.resultId !== undefined) {
      <div
        class="alert alert-warning"
        role="alert">
        <h2 class="alert-heading"><i class="fas fa-exclamation-triangle"></i> Attention! Les résultats pourraient ne
      plus être à jour. </h2>
      Puisque des modifications ont été apportése aux valeurs du formulaire, il se pourrait que les résultats ne
      soient pas à jour.
      Pour vous assurez que les résultats soient bien à jour avec les nouvelles valeurs, veuillez rouler le calcul
      de nouveau.
      <br>
        <br>
          <div>
            <a href="" routerLink="../" style="margin-right: 15px;">Retour au formulaire</a>
          </div>
        </div>
      }
      @if (calculationResponse?.status === CalculationStatusEnum.Created  && calculationResponse?.resultId === undefined) {
        <div
          class="alert alert-warning"
          role="alert">
          <h2 class="alert-heading"><i class="fas fa-exclamation-triangle"></i> Résultats indisponibles</h2>
          Afin de voir les résulats, vous devez rouler le calcul au moins une fois.
          <br>
            <br>
              <div>
                <a class="btn btn-sm btn-secondary" href="" routerLink="../" style="margin-right: 15px;">Retourner au
                formulaire</a>
              </div>
            </div>
          }

          @if (calculationResponse?.status === CalculationStatusEnum.Error) {
            <div class="alert alert-danger"
              role="alert">
              <h2 class="alert-heading"><i class="fas fa-exclamation-circle"></i> Certaines erreurs se sont produites.
            Vous les corriger en retournant au formulaire. </h2>
            <ul>
              @for (error of calculationResponse.results?.errors; track error) {
                <li
                  style="font-size:14pt;">{{ getErrorText(error) }}
                </li>
              }
            </ul>
            <div class="mt-5">
              <a class="btn btn-sm btn-secondary" href="" routerLink="../">Retourner au formulaire</a>
            </div>
          </div>
        }

        @if (calculationStatusEnum === CalculationStatusEnum.Completed && calculationResponse.results?.warnings?.length > 0) {
          <div
            class="alert alert-warning"
            role="alert">
            <h2 class="alert-heading"><i class="fas fa-exclamation-circle me-3"></i> Votre calcul s'est complété avec
          quelques avertissements </h2>
          <ul>
            @for (warning of calculationResponse.results?.warnings; track warning) {
              <li
                style="font-size:14pt;">{{ warning }}
              </li>
            }
          </ul>
          <div class="mt-5">
            <a class="btn btn-sm btn-secondary" href="" routerLink="../" style="margin-right: 15px;">Retourner au
            formulaire</a>
          </div>
        </div>
      }

      @if (this.calculationStatusEnum === CalculationStatusEnum.InProgress) {
        <div class="alert alert-primary">
          <h2 class="alert-heading mt-2 mb-2"><i class="fas fa-circle-notch fa-spin me-3"></i> Calcul en cours
        d'exécution.</h2>
      </div>
    }
  </div>
</div>

@if (calculationStatusEnum === CalculationStatusEnum.Completed) {
  <div class="row">
    <div class="col-12 d-flex">
      <h1 class="flex-grow-1">Résultats</h1>
      <!--        todo: re-add this feature<app-export-calculation-results [calculation]="this.calculationResponse"></app-export-calculation-results>-->
    </div>
  </div>
}



<div class="row">
  <div class="col-12">
    <div [class.visually-hidden]="calculationResponse?.results === undefined || calculationStatusEnum !== CalculationStatusEnum.Completed"
      id="graph-container">
      <h2>Graphique</h2>
      <magieno-radio-buttons [advancedFormControl]="selectGraphForm.formElements.selectedGraph | asAdvancedFormControl"></magieno-radio-buttons>
      <canvas class="d-print-block" id="amount-graph" [hidden]="selectGraphForm.value.selectedGraph !== 'amountGraph'"></canvas>
      <canvas class="d-print-block" id="ratio-graph" [hidden]="selectGraphForm.value.selectedGraph !== 'ratioGraph'"></canvas>
    </div>
  </div>
</div>

<div class="pagebreak"></div>
<div class="row">
  <div class="col-12">
    <div *ngIf="calculationResponse?.results !== undefined && calculationStatusEnum === CalculationStatusEnum.Completed"
         class="results">


      <div class="row mt-3">
        <h2 (click)="rrspSavings.toggle()"
            [attr.aria-expanded]="!isSectionRrspSavingsCollapsed"
            aria-controls="rrspSabings">
          Économie réalisée avec la déduction REER
        </h2>
        <div class="text-center d-print-none" style="bottom: 10px; width: 100%;">
          <button (click)="rrspSavings.toggle()"
                  class="shadow btn btn-link btn-outline-light rounded-pill"
                  style="">
            <span *ngIf="isSectionRrspSavingsCollapsed"><i class="fas fa-angle-double-down"></i> Agrandir</span>
            <span *ngIf="!isSectionRrspSavingsCollapsed"><i class="fas fa-angle-double-up"></i> Réduire</span>
          </button>
        </div>
        <div #rrspSavings="ngbCollapse" [(ngbCollapse)]="isSectionRrspSavingsCollapsed">
          <div class="card table-result-card">
            <div class="card-body">
              <div class="row">
                <div class="col-12">

                  <div class="table-result table-result-row table-result-row-indent-0">
                    <div class="table-result-col table-result-col-no-dots"></div>
                    <div class="table-result-col table-result-col-value">0% de cotisations REER</div>
                    <div class="table-result-col table-result-col-value">100% de cotisations REER</div>
                  </div>

                  <div class="table-result table-result-row table-result-row-indent-0">
                    <app-output-variable
                            [selectedBadge]="selectedBadge"
                            [style]="'primary'" [text]="'Imp perso'"
                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                    <div class="table-result-col table-result-col-description">Impôt personnel après l'ajout du REER </div>
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ 0 | currencyCents | notAvailable }}</div>-->
                  </div>

                  <div class="table-result table-result-row table-result-row-indent-0">
                    <app-output-variable
                            [selectedBadge]="selectedBadge"
                            [style]="'primary'" [text]="'Imp Fed Act'"
                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                    <div class="table-result-col table-result-col-description">Impôt personnel fédéral du particulier</div>
                    <div class="table-result-col table-result-col-dots"></div>
                    <div class="table-result-col table-result-col-value">{{ results?.withoutRrsp?.personalIncomeTax?.mainPerson?.federal?.lineResult | currencyCents | notAvailable }}</div>
                    <div class="table-result-col table-result-col-value">{{ results?.fullRrsp?.personalIncomeTax?.mainPerson?.federal?.lineResult | currencyCents | notAvailable }}</div>
                  </div>

                  <div class="table-result table-result-row table-result-row-indent-0">
                    <app-output-variable
                            [selectedBadge]="selectedBadge"
                            [style]="'primary'" [text]="'Imp QC Act'"
                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                    <div class="table-result-col table-result-col-description">Impôt personnel Québec du particulier</div>
                    <div class="table-result-col table-result-col-dots"></div>
                    <div class="table-result-col table-result-col-value">{{ results?.withoutRrsp?.personalIncomeTax?.mainPerson?.quebec?.line470 | currencyCents | notAvailable }}</div>
                    <div class="table-result-col table-result-col-value">{{ results?.fullRrsp?.personalIncomeTax?.mainPerson?.quebec?.line470 | currencyCents | notAvailable }}</div>
                  </div>

                  <div class="table-result table-result-row table-result-row-indent-0">
                    <app-output-variable
                            [selectedBadge]="selectedBadge"
                            [style]="'primary'" [text]="'Imp Fed Cjt'"
                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                    <div class="table-result-col table-result-col-description">Impôt personnel fédéral du conjoint</div>
                    <div class="table-result-col table-result-col-dots"></div>
                    <div class="table-result-col table-result-col-value">{{ results?.withoutRrsp?.personalIncomeTax?.spouse?.federal?.lineResult | currencyCents | notAvailable }}</div>
                    <div class="table-result-col table-result-col-value">{{ results?.fullRrsp?.personalIncomeTax?.spouse?.federal?.lineResult | currencyCents | notAvailable }}</div>
                  </div>

                  <div class="table-result table-result-row table-result-row-indent-0">
                    <app-output-variable
                            [selectedBadge]="selectedBadge"
                            [style]="'primary'" [text]="'Imp QC Cjt'"
                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                    <div class="table-result-col table-result-col-description">Impôt personnel Québec du conjoint</div>
                    <div class="table-result-col table-result-col-dots"></div>
                    <div class="table-result-col table-result-col-value">{{ results?.withoutRrsp?.personalIncomeTax?.spouse?.quebec?.line470 | currencyCents | notAvailable }}</div>
                    <div class="table-result-col table-result-col-value">{{ results?.fullRrsp?.personalIncomeTax?.spouse?.quebec?.line470 | currencyCents | notAvailable }}</div>
                  </div>

                  <div class="table-result table-result-row table-result-row-indent-0">
                    <app-output-variable
                            [selectedBadge]="selectedBadge"
                            [style]="'primary'" [text]="'Déb perso'"
                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
                    <div class="table-result-col table-result-col-description">Liquidité
                      disponible personnelle (coût de vie)
                    </div>
                    <div class="table-result-col table-result-col-dots"></div>
                    <div class="table-result-col table-result-col-description text-end d-print-none">
                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                                           [text]="'Imp Fed Act'"></app-output-variable>
                      +
                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                                           [text]="'Imp QC Act'"></app-output-variable>
                      +
                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                                           [text]="'Imp Fed Cjt'"></app-output-variable>
                      +
                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                                           [text]="'Imp QC Cjt'"></app-output-variable>
                      =
                    </div>
                    <div class="table-result-col table-result-col-value">{{ results?.withoutRrsp?.personalIncomeTax?.totalTaxes | currencyCents | notAvailable }}</div>
                    <div class="table-result-col table-result-col-value">{{ results?.fullRrsp?.personalIncomeTax?.totalTaxes | currencyCents | notAvailable }}</div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

<!--      <h2> Déclaration de revenus fédérale</h2>-->

<!--      <div class="row mt-5">-->
<!--        <h2 (click)="collapseCorporateDisbursement.toggle()"-->
<!--            [attr.aria-expanded]="!isSectionCorporateDisbursementCollapsed"-->
<!--            aria-controls="corporateDisbursement">-->
<!--          Déboursé corporatif-->
<!--        </h2>-->
<!--        <div class="text-center d-print-none" style="bottom: 10px; width: 100%;">-->
<!--          <button (click)="collapseCorporateDisbursement.toggle()"-->
<!--                  class="shadow btn btn-link btn-outline-light rounded-pill"-->
<!--                  style="">-->
<!--                            <span *ngIf="isSectionCorporateDisbursementCollapsed"><i-->
<!--                                    class="fas fa-angle-double-down"></i> Agrandir</span>-->
<!--            <span *ngIf="!isSectionCorporateDisbursementCollapsed"><i-->
<!--                    class="fas fa-angle-double-up"></i> Réduire</span>-->
<!--          </button>-->
<!--        </div>-->
<!--        <div #collapseCorporateDisbursement="ngbCollapse"-->
<!--             [(ngbCollapse)]="isSectionCorporateDisbursementCollapsed">-->
<!--          <div class="card table-result-card">-->
<!--            <div class="card-body">-->
<!--              <div class="row">-->
<!--                <div class="col-12">-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <div class="table-result-col table-result-col-no-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">Salaire</div>-->
<!--                    <div class="table-result-col table-result-col-value">Dividende</div>-->
<!--                    <div class="table-result-col table-result-col-value">Optimisation</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'Div Ord'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">Dividende-->
<!--                      ordinaire-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ 0 | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withDividendOnly?.realDividend?.nonEligible | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.optimum?.realDividend?.nonEligible | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'Div Det'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">Dividende-->
<!--                      déterminé-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ 0 | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withDividendOnly?.realDividend?.eligible | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.optimum?.realDividend?.eligible | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'Salaire'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">Salaire</div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withSalaryOnly?.salary | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ 0 | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.optimum?.salary | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'Cot corpo'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">Cotisation de-->
<!--                      l'employeur (Note 3)-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withSalaryOnly?.employerContribution | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withDividendOnly?.employerContribution | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.optimum?.employerContribution | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'Impo econo'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">Impôt corporatif-->
<!--                      économisé-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withSalaryOnly?.corporate?.taxSaving | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withDividendOnly?.corporate?.taxSaving | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.optimum?.corporate?.taxSaving | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'Div RRQ'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">Valeur actualisée corporative de la-->
<!--                      pension RRQ-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withSalaryOnly?.futureDividendExcedent | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withDividendOnly?.futureDividendExcedent | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.optimum?.futureDividendExcedent | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'Déb corpo'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">Déboursé-->
<!--                      corporatif-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-description text-end d-print-none">-->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'Div ord'"></app-output-variable>-->
<!--                      +-->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'Div dét'"></app-output-variable>-->
<!--                      +-->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'Salaire'"></app-output-variable>-->
<!--                      +-->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'Cot corpo'"></app-output-variable>-->
<!--                      - -->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'Impo econo'"></app-output-variable>-->
<!--                      - -->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'Div RRQ'"></app-output-variable>-->
<!--                      =-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withSalaryOnly?.corporate?.cashDisbursement | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withDividendOnly?.corporate?.cashDisbursement | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.optimum?.corporate?.cashDisbursement | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                </div>-->
<!--              </div>-->

<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--      <hr class="d-print-none">-->
<!--      <div class="pagebreak"></div>-->

<!--      <div class="row">-->
<!--        <h2 (click)="collapseNote1.toggle()"-->
<!--            [attr.aria-expanded]="!isSectionNote1Collapsed"-->
<!--            aria-controls="note1"-->
<!--            id="note1"-->
<!--        >-->
<!--          Note 1 - Cotisations de l'employé supplémentaires-->
<!--        </h2>-->
<!--        <div class="text-center d-print-none" style="bottom: 10px; width: 100%;">-->
<!--          <button (click)="collapseNote1.toggle()" class="shadow btn btn-link btn-outline-light rounded-pill"-->
<!--                  style="">-->
<!--                            <span *ngIf="isSectionNote1Collapsed"><i-->
<!--                                    class="fas fa-angle-double-down"></i> Agrandir</span>-->
<!--            <span *ngIf="!isSectionNote1Collapsed"><i class="fas fa-angle-double-up"></i> Réduire</span>-->
<!--          </button>-->
<!--        </div>-->
<!--        <div #collapseNote1="ngbCollapse" [(ngbCollapse)]="isSectionNote1Collapsed">-->
<!--          <div class="card table-result-card">-->
<!--            <div class="card-body">-->
<!--              <div class="row">-->
<!--                <div class="col-12">-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <div class="table-result-col table-result-col-no-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">Salaire</div>-->
<!--                    <div class="table-result-col table-result-col-value">Dividende</div>-->
<!--                    <div class="table-result-col table-result-col-value">Optimisation</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'RRQ AP'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">RRQ après la-->
<!--                      simulation-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withSalaryOnly?.incomeTaxPersonal?.mainPerson?.salaryContributions?.schedule8?.part2?.line11 | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withDividendOnly?.incomeTaxPersonal?.mainPerson?.salaryContributions?.schedule8?.part2?.line11 | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.optimum?.incomeTaxPersonal?.mainPerson?.salaryContributions?.schedule8?.part2?.line11 | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'RQAP AP'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">RQAP après la-->
<!--                      simulation-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withSalaryOnly?.incomeTaxPersonal?.mainPerson?.salaryContributions?.scheduleR?.line37 | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withDividendOnly?.incomeTaxPersonal?.mainPerson?.salaryContributions?.scheduleR?.line37 | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.optimum?.incomeTaxPersonal?.mainPerson?.salaryContributions?.scheduleR?.line37  | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'AE AP'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">AE après la-->
<!--                      simulation-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withSalaryOnly?.incomeTaxPersonal?.mainPerson?.salaryContributions?.schedule10?.line20  | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withDividendOnly?.incomeTaxPersonal?.mainPerson?.salaryContributions?.schedule10?.line20 | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.optimum?.incomeTaxPersonal?.mainPerson?.salaryContributions?.schedule10?.line20 | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-1">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'COT AP'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">Total des-->
<!--                      cotisations de l'employé après la simulation-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-description text-end d-print-none">-->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'RRQ AP'"></app-output-variable>-->
<!--                      +-->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'RQAP AP'"></app-output-variable>-->
<!--                      +-->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'AE AP'"></app-output-variable>-->
<!--                      =-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withSalaryOnly?.incomeTaxPersonal?.mainPerson?.salaryContributions?.employeeContributions | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withDividendOnly?.incomeTaxPersonal?.mainPerson?.salaryContributions?.employeeContributions | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.optimum?.incomeTaxPersonal?.mainPerson?.salaryContributions?.employeeContributions | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'RRQ AV'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">RRQ avant la-->
<!--                      simulation-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withoutSalaryNorDividend?.incomeTaxPersonal?.mainPerson?.salaryContributions?.schedule8?.part2?.line11 | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withoutSalaryNorDividend?.incomeTaxPersonal?.mainPerson?.salaryContributions?.schedule8?.part2?.line11 | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withoutSalaryNorDividend?.incomeTaxPersonal?.mainPerson?.salaryContributions?.schedule8?.part2?.line11 | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'RQAP AV'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">RQAP avant la-->
<!--                      simulation-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withoutSalaryNorDividend?.incomeTaxPersonal?.mainPerson?.salaryContributions?.scheduleR?.line37 | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withoutSalaryNorDividend?.incomeTaxPersonal?.mainPerson?.salaryContributions?.scheduleR?.line37 | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withoutSalaryNorDividend?.incomeTaxPersonal?.mainPerson?.salaryContributions?.scheduleR?.line37  | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'AE AV'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">AE avant la-->
<!--                      simulation-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withoutSalaryNorDividend?.incomeTaxPersonal?.mainPerson?.salaryContributions?.schedule10?.line20 | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withoutSalaryNorDividend?.incomeTaxPersonal?.mainPerson?.salaryContributions?.schedule10?.line20 | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withoutSalaryNorDividend?.incomeTaxPersonal?.mainPerson?.salaryContributions?.schedule10?.line20 | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-1">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'COT AV'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">Total des-->
<!--                      cotisations de l'employé avant la simulation-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-description text-end d-print-none">-->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'RRQ AV'"></app-output-variable>-->
<!--                      +-->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'RQAP AV'"></app-output-variable>-->
<!--                      +-->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'AE AV'"></app-output-variable>-->
<!--                      =-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withoutSalaryNorDividend?.incomeTaxPersonal?.mainPerson?.salaryContributions?.employeeContributions | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withoutSalaryNorDividend?.incomeTaxPersonal?.mainPerson?.salaryContributions?.employeeContributions | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withoutSalaryNorDividend?.incomeTaxPersonal?.mainPerson?.salaryContributions?.employeeContributions | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-1">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'COT'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">Cotisations de-->
<!--                      l'employé supplémentaires-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-description text-end d-print-none">-->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'COT AP'"></app-output-variable>-->
<!--                      - -->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'COT AV'"></app-output-variable>-->
<!--                      =-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withSalaryOnly?.shareholderContributionExcedent| currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withDividendOnly?.shareholderContributionExcedent | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.optimum?.shareholderContributionExcedent | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                </div>-->
<!--              </div>-->

<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="pagebreak"></div>-->

<!--      <div class="row">-->
<!--        <h2 (click)="collapseNote2.toggle()"-->
<!--            [attr.aria-expanded]="!isSectionNote2Collapsed"-->
<!--            aria-controls="note2"-->
<!--            id="note2"-->
<!--        >-->
<!--          Note 2 - Impot personnel supplémentaire-->
<!--        </h2>-->
<!--        <div class="text-center d-print-none" style="bottom: 10px; width: 100%;">-->
<!--          <button (click)="collapseNote2.toggle()" class="shadow btn btn-link btn-outline-light rounded-pill"-->
<!--                  style="">-->
<!--                            <span *ngIf="isSectionNote2Collapsed"><i-->
<!--                                    class="fas fa-angle-double-down"></i> Agrandir</span>-->
<!--            <span *ngIf="!isSectionNote2Collapsed"><i class="fas fa-angle-double-up"></i> Réduire</span>-->
<!--          </button>-->
<!--        </div>-->
<!--        <div #collapseNote2="ngbCollapse" [(ngbCollapse)]="isSectionNote2Collapsed">-->
<!--          <div class="card table-result-card table-result-smaller-font-on-print">-->
<!--            <div class="card-body">-->
<!--              <div class="row">-->
<!--                <div class="col-12">-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <div class="table-result-col table-result-col-no-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">Salaire</div>-->
<!--                    <div class="table-result-col table-result-col-value">Dividende</div>-->
<!--                    <div class="table-result-col table-result-col-value">Optimisation</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'FED AP 1'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">Impôts personnels-->
<!--                      fédérals de l'actionnaire après simulation-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withSalaryOnly?.incomeTaxPersonal?.mainPerson?.federal?.lineResult | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withDividendOnly?.incomeTaxPersonal?.mainPerson?.federal?.lineResult | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.optimum?.incomeTaxPersonal?.mainPerson?.federal?.lineResult | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'QC AP 1'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">Impôts personnels-->
<!--                      Québec de l'actionnaire après simulation-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withSalaryOnly?.incomeTaxPersonal?.mainPerson?.quebec?.line470 | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withDividendOnly?.incomeTaxPersonal?.mainPerson?.quebec?.line470  | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.optimum?.incomeTaxPersonal?.mainPerson?.quebec?.line470   | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'FED AP 2'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">Impôts personnels-->
<!--                      fédérals du conjoint après simulation-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withSalaryOnly?.incomeTaxPersonal?.spouse?.federal?.lineResult | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withDividendOnly?.incomeTaxPersonal?.spouse?.federal?.lineResult | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.optimum?.incomeTaxPersonal?.spouse?.federal?.lineResult | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'QC AP 2'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">Impôts personnels-->
<!--                      Québec du conjoint après simulation-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withSalaryOnly?.incomeTaxPersonal?.spouse?.quebec?.line470 | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withDividendOnly?.incomeTaxPersonal?.spouse?.quebec?.line470  | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.optimum?.incomeTaxPersonal?.spouse?.quebec?.line470   | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-1">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'PERSO AP'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">Total de l'impôt-->
<!--                      personnel après la simulation-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-description text-end d-print-none">-->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'FED AP 1'"></app-output-variable>-->
<!--                      +-->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'QC AP 1'"></app-output-variable>-->
<!--                      +-->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'FED AP 2'"></app-output-variable>-->
<!--                      +-->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'QC AP 2'"></app-output-variable>-->
<!--                      =-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withSalaryOnly?.incomeTaxPersonal?.totalTaxes| currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withDividendOnly?.incomeTaxPersonal?.totalTaxes | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.optimum?.incomeTaxPersonal?.totalTaxes | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'FED AV 1'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">Impôts personnels-->
<!--                      fédérals de l'actionnaire avant simulation-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withoutSalaryNorDividend?.incomeTaxPersonal?.mainPerson?.federal?.lineResult | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withoutSalaryNorDividend?.incomeTaxPersonal?.mainPerson?.federal?.lineResult | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withoutSalaryNorDividend?.incomeTaxPersonal?.mainPerson?.federal?.lineResult | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'QC AV 1'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">Impôts personnels-->
<!--                      Québec de l'actionnaire avant simulation-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withoutSalaryNorDividend?.incomeTaxPersonal?.mainPerson?.quebec?.line470 | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withoutSalaryNorDividend?.incomeTaxPersonal?.mainPerson?.quebec?.line470  | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withoutSalaryNorDividend?.incomeTaxPersonal?.mainPerson?.quebec?.line470   | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'FED AV 2'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">Impôts personnels-->
<!--                      fédérals du conjoint avant simulation-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withoutSalaryNorDividend?.incomeTaxPersonal?.spouse?.federal?.lineResult | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withoutSalaryNorDividend?.incomeTaxPersonal?.spouse?.federal?.lineResult | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withoutSalaryNorDividend?.incomeTaxPersonal?.spouse?.federal?.lineResult | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'QC AV 2'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">Impôts personnels-->
<!--                      Québec du conjoint avant simulation-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withoutSalaryNorDividend?.incomeTaxPersonal?.spouse?.quebec?.line470 | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withoutSalaryNorDividend?.incomeTaxPersonal?.spouse?.quebec?.line470 | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withoutSalaryNorDividend?.incomeTaxPersonal?.spouse?.quebec?.line470 | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-1">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'PERSO AV'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">Total de l'impôt-->
<!--                      personnel avant la simulation-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-description text-end d-print-none">-->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'FED AV 1'"></app-output-variable>-->
<!--                      +-->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'QC AV 1'"></app-output-variable>-->
<!--                      +-->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'FED AV 2'"></app-output-variable>-->
<!--                      +-->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'QC AV 2'"></app-output-variable>-->
<!--                      =-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withoutSalaryNorDividend?.incomeTaxPersonal?.totalTaxes| currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withoutSalaryNorDividend?.incomeTaxPersonal?.totalTaxes | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withoutSalaryNorDividend?.incomeTaxPersonal?.totalTaxes | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-1">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'PERSO'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">Impôt peronnels-->
<!--                      supplémentaires-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-description text-end d-print-none">-->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'PERSO AP'"></app-output-variable>-->
<!--                      - -->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'PERSO AV'"></app-output-variable>-->
<!--                      =-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withSalaryOnly?.shareholderTaxExcedent| currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withDividendOnly?.shareholderTaxExcedent | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.optimum?.shareholderTaxExcedent | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                </div>-->
<!--              </div>-->

<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="pagebreak"></div>-->

<!--      <div class="row">-->
<!--        <h2 (click)="collapseNote3.toggle()"-->
<!--            [attr.aria-expanded]="!isSectionNote3Collapsed"-->
<!--            aria-controls="note3"-->
<!--            id="note3"-->
<!--        >-->
<!--          Note 3 - Cotisations de l'employeur-->
<!--        </h2>-->
<!--        <div class="text-center d-print-none" style="bottom: 10px; width: 100%;">-->
<!--          <button (click)="collapseNote3.toggle()" class="shadow btn btn-link btn-outline-light rounded-pill"-->
<!--                  style="">-->
<!--                            <span *ngIf="isSectionNote3Collapsed"><i-->
<!--                                    class="fas fa-angle-double-down"></i> Agrandir</span>-->
<!--            <span *ngIf="!isSectionNote3Collapsed"><i class="fas fa-angle-double-up"></i> Réduire</span>-->
<!--          </button>-->
<!--        </div>-->
<!--        <div #collapseNote3="ngbCollapse" [(ngbCollapse)]="isSectionNote3Collapsed">-->
<!--          <div class="card table-result-card">-->
<!--            <div class="card-body">-->
<!--              <div class="row">-->
<!--                <div class="col-12">-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <div class="table-result-col table-result-col-no-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">Salaire</div>-->
<!--                    <div class="table-result-col table-result-col-value">Dividende</div>-->
<!--                    <div class="table-result-col table-result-col-value">Optimisation</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'RRQ'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">RRQ payé par-->
<!--                      l'employeur-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withSalaryOnly?.incomeTaxPersonal?.mainPerson?.salaryContributions?.schedule8?.part2?.line11 | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ 0 | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.optimum?.incomeTaxPersonal?.mainPerson?.salaryContributions?.schedule8?.part2?.line11 | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'RQAP'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">RQAP payé par-->
<!--                      l'employeur-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withSalaryOnly?.incomeTaxPersonal?.mainPerson?.salaryContributions?.scheduleR?.qPIPEmployerContributions | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ 0 | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.optimum?.incomeTaxPersonal?.mainPerson?.salaryContributions?.scheduleR?.qPIPEmployerContributions  | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'AE'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">AE payé par-->
<!--                      l'employeur-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withSalaryOnly?.incomeTaxPersonal?.mainPerson?.salaryContributions?.schedule10?.eIEmployerContributions | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ 0 | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.optimum?.incomeTaxPersonal?.mainPerson?.salaryContributions?.schedule10?.eIEmployerContributions | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'FSS'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">FSS payé par-->
<!--                      l'employeur-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withSalaryOnly?.mainPerson?.salaryContributions?.fSS?.contributions | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ 0 | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.optimum?.mainPerson?.salaryContributions?.fSS?.contributions   | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'CNT'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">CNT payé par-->
<!--                      l'employeur-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withSalaryOnly?.mainPerson?.salaryContributions?.cNT?.line35 | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ 0 | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.optimum?.mainPerson?.salaryContributions?.cNT?.line35   | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-0">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'CNESST'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">CNESST payé par-->
<!--                      l'employeur-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withSalaryOnly?.mainPerson?.salaryContributions?.cNESST?.contribution | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ 0 | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.optimum?.mainPerson?.salaryContributions?.cNESST?.contribution  | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->

<!--                  <div class="table-result table-result-row table-result-row-indent-1">-->
<!--                    <app-output-variable-->
<!--                            [selectedBadge]="selectedBadge"-->
<!--                            [style]="'primary'" [text]="'COT EM'"-->
<!--                            class="table-result-col table-result-col-output-variable-badge"></app-output-variable>-->
<!--                    <div class="table-result-col table-result-col-description">Cotisations de-->
<!--                      l'employeur-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-dots"></div>-->
<!--                    <div class="table-result-col table-result-col-description text-end d-print-none">-->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'RRQ'"></app-output-variable>-->
<!--                      +-->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'RQAP'"></app-output-variable>-->
<!--                      +-->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'AE'"></app-output-variable>-->
<!--                      +-->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'FSS'"></app-output-variable>-->
<!--                      +-->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'CNT'"></app-output-variable>-->
<!--                      +-->
<!--                      <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"-->
<!--                                           [text]="'CNESST'"></app-output-variable>-->
<!--                      =-->
<!--                    </div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.withSalaryOnly?.employerContribution | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ 0 | currencyCents | notAvailable }}</div>-->
<!--                    <div class="table-result-col table-result-col-value">{{ results?.optimum?.employerContribution | currencyCents | notAvailable }}</div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->

<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
</div>
